module.exports = __webpack_public_path__ + "43c9dcb2479590c6c8997a879bc03d1d.png";